import React from 'react'

function TrendingDownIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13.729" height="8.774" viewBox="0 0 13.729 8.774">
            <g id="Icon_feather-trending-up" data-name="Icon feather-trending-up" transform="translate(1.414 1.414)">
                <path id="Path_25994" data-name="Path 25994" d="M12.4,14.945,7.693,10.239,5.216,12.716,1.5,9" transform="translate(-1.5 -9)" fill="none" stroke="#ff3535" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                <path id="Path_25995" data-name="Path 25995" d="M25.5,11.973h2.973V9" transform="translate(-17.572 -6.027)" fill="none" stroke="#ff3535" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
            </g>
        </svg>
    )
}

export default TrendingDownIcon